export default __webpack_public_path__ + "static/media/users.475641bf.svg";